import React, { useState, useEffect } from 'react';
import Layout from "../../components/Wrappers/Layout";
import CustomButton from "../../components/CustomButton/CustomButton";
import EditIcon from "@mui/icons-material/Edit";
import { makeStyles } from "@mui/styles";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SOLogout from "../../components/Logout/SOLogout";
import {
    Card,
    Alert,
} from "reactstrap";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import { AddOrUpdateSubModulesMasterAdminLists } from "../../redux/actions/addOrUpdateSubModuleForAdminAction";
import { GetSubModulesMasterForAdminLists } from "../../redux/actions/getSubModuleMasterForAdminAction"
import BackButton from '../../components/BackButton/BackButton';
import { useDispatch, useSelector } from 'react-redux';
import { AiOutlineSearch } from "react-icons/ai";
import SearchIcon from "@mui/icons-material/Search";
import val from "../../getThemeDetails";

const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

const AddSubModulesAdmin = () => {

    const [subModuleName, setsubModuleName] = useState('');
    const [role, setrole] = useState('');
    const [masterModuleId, setmasterModuleId] = useState();
    const [moduleId, setmoduleId] = useState('');
    const [isLoading, setisLoading] = useState(false);
    const [getSubModuleMasterTable, setgetSubModuleMasterTable] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [page, setPage] = useState(0);
    const [editOpen, seteditOpen] = useState(false);
    const [editSubModuleName, seteditSubModuleName] = useState('');
    const [editsubModuleRole, seteditsubModuleRole] = useState('');
    const [editsubModuleId, seteditsubModuleId] = useState('');
    const [editMasterModuleId, seteditMasterModuleId] = useState('');
    const [editMasterModuleName, seteditMasterModuleName] = useState('');
    const [addSubModuleModal, setaddSubModuleModal] = useState(false);
    const [masterModuleValues, setmasterModuleValues] = useState([]); //dropdown of master module values
    const [addSubModuleName, setaddSubModuleName] = useState('');
    const [addSubModuleRole, setaddSubModuleRole] = useState('');
    const [addMasterModule, setaddMasterModule] = useState('');
    const [editUpdateSet, seteditUpdateSet] = useState(false);
    const [editSubModuleResp, seteditSubModuleResp] = useState('');
    const [notificationOpen, setnotificationOpen] = useState(false);
    const [editModuleName, seteditModuleName] = useState('');
    const [addset, setaddset] = useState(false);

    const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
    const dispatch = useDispatch();
    const classes = useStyles();

    let authToken = regenerateTokenRes.data.AuthToken;
    const addupdatesubmodulemaster = useSelector(({ adminAddOrUpdateSubModulesMasterLists }) => adminAddOrUpdateSubModulesMasterLists);
    const getSubModuleMasterAdminRes = useSelector(({ adminGetSubModulesMasterLists }) => adminGetSubModulesMasterLists);
    const getModuleMasterAdminListRes = useSelector(({ adminModulesMastersLists }) => adminModulesMastersLists);


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const setMasterMododuleName = () => {
        if (getModuleMasterAdminListRes.data.status === 'success') {
            setmasterModuleValues([].concat(getModuleMasterAdminListRes.data.errorList));
        }
    }
    useEffect(() => {
        setMasterMododuleName();
    }, [getModuleMasterAdminListRes.data.status]);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const closeaddModuleModal = () => {
        setaddSubModuleModal(false);
    }
    const handleChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'subModuleName') {
            setsubModuleName(value);
        }
        if (name === 'role') {
            setrole(value);
        }
        if (name === 'masterModuleId') {
            setmasterModuleId(value);
        }
        if (name === 'moduleId') {
            setmoduleId(value);
        }
    }
    const addSubModuleChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'addSubModuleName') {
            setaddSubModuleName(value);
        }
        if (name === 'addSubModuleRole') {
            setaddSubModuleRole(value);
        }
        if (name === 'addMasterModule') {
            setaddMasterModule(value)
        }
    }
    const handleNoticationClose = () => {
        setnotificationOpen(false);
        setaddMasterModule('');
        setaddSubModuleName('');
        setaddSubModuleRole('');
    }

    const editModalOpen = (mastermoduleName, subModuleName, subModuleRole, subModuleId, masterModuleId, masterModuleName) => {
        seteditUpdateSet(true);
        seteditsubModuleId(subModuleId);
        seteditMasterModuleName(mastermoduleName);
        seteditMasterModuleId(masterModuleId);
        seteditModuleName(masterModuleName)
        seteditSubModuleName(subModuleName);
        seteditsubModuleRole(subModuleRole === '-' ? '' : subModuleRole.toUpperCase());
        seteditOpen(true);
    }

    const handleClose = () => {
        // seteditSubModuleName('');
        // seteditsubModuleRole('');
        seteditOpen(false);
    }
    const changeEdit = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'editSubModuleName') {
            seteditSubModuleName(value);
        }
        if (name === 'editsubModuleRole') {
            seteditsubModuleRole(value);
        }
    }
    const editFunction = () => {
        const editReq = {
            actionCustomerMasterRequestVO: {
                moduleId: editsubModuleId,
                subModuleName: editSubModuleName,
                role: editsubModuleRole === '-' ? '' : editsubModuleRole,
                masterModuleId: editMasterModuleId,
                moduleName: editModuleName
            }
        }
        dispatch(AddOrUpdateSubModulesMasterAdminLists(editReq, authToken));
    }
    const addSubModuleSubmit = () => {
        const addReq = {
            actionCustomerMasterRequestVO: {
                subModuleName: addSubModuleName,
                role: addSubModuleRole,
                moduleId: '',
                moduleName: addMasterModule.substring(0, addMasterModule.indexOf('-')),
                masterModuleId: addMasterModule.substring(addMasterModule.indexOf('-') + 1)
            }
        }
        dispatch(AddOrUpdateSubModulesMasterAdminLists(addReq, authToken));

    }

    const addUpdateShowRespFunc = () => {
        if (editUpdateSet) {
            if (addupdatesubmodulemaster.data.status === 'success') {
                seteditSubModuleResp(addupdatesubmodulemaster.data.description);
                seteditOpen(false);
                setnotificationOpen(true);
                searchFunction();
            }
            if (addupdatesubmodulemaster.data.status === 'failed') {
                seteditSubModuleResp(addupdatesubmodulemaster.data.description);
                seteditOpen(false);
                setnotificationOpen(true);
                searchFunction();
                if (
                    addupdatesubmodulemaster.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    addupdatesubmodulemaster.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
        if (addset) {
            if (addupdatesubmodulemaster.data.status === 'success') {
                seteditSubModuleResp(addupdatesubmodulemaster.data.description);
                setaddSubModuleModal(false);
                setnotificationOpen(true);
                searchFunction();
            }
            if (addupdatesubmodulemaster.data.status === 'failed') {
                seteditSubModuleResp(addupdatesubmodulemaster.data.description);
                setaddSubModuleModal(false);
                setnotificationOpen(true);
                searchFunction();
                if (
                    addupdatesubmodulemaster.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    addupdatesubmodulemaster.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }

    useEffect(() => {
        addUpdateShowRespFunc();
    }, [addupdatesubmodulemaster.data.status])

    const openAddSubModule = () => {
        setaddset(true);
        setaddSubModuleModal(true);
    }

    const searchFunction = () => {
        setisLoading(true);
        const getReq = {
            actionCustomerMasterRequestVO: {
                adminId: val.adminIDS,
                // adminId: "2",
                subModuleName: subModuleName,
                role: role,
                // masterModuleId: masterModuleId,
                moduleId: moduleId
            }
        }
        dispatch(GetSubModulesMasterForAdminLists(getReq, authToken));
    }
    useEffect(() => {
        getSubModuleMasterFunc();
    }, [])

    const getSubModuleMasterFunc = () => {
        if (getSubModuleMasterAdminRes) {
            if (getSubModuleMasterAdminRes.data.status === 'success') {
                setgetSubModuleMasterTable([].concat(getSubModuleMasterAdminRes.data.errorList));
                setisLoading(false);
            }
            if (getSubModuleMasterAdminRes.data.status === 'failed') {
                setgetSubModuleMasterTable([]);
                setisLoading(false);
                if (
                    getSubModuleMasterAdminRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getSubModuleMasterAdminRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }
    useEffect(() => {
        getSubModuleMasterFunc();
    }, [getSubModuleMasterAdminRes.data.status]);

        useEffect(() => {
            if (getSubModuleMasterAdminRes.data.status == "success") {
                setPage(0);
            }
        }, [getSubModuleMasterAdminRes.data.status]);

    return (
        <>
            <Layout>
                <BackButton />
                <Card>
                    <Grid
                        container
                        style={{ padding: "15px", justifyContent: "right" }}
                        spacing={2}
                    >
                        <Grid item md={2} sm={12} xs={12} lg={3}>
                            {/* <NavLink to="/index/adminAddSubModule"> */}
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                variant="contained"
                                className="riskRuleButton"
                                onClick={openAddSubModule}
                            >
                                Add Sub Module
                            </CustomButton>
                            {/* </NavLink> */}
                        </Grid>
                    </Grid>

                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item sm={12} md={6} lg={3}>
                            <TextField
                                autoFocus
                                margin="dense"
                                id="name"
                                label="Sub Module Name"
                                type="name"
                                fullWidth
                                variant="standard"
                                name="subModuleName"
                                onChange={handleChange}
                                defaultValue={"" || subModuleName}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            >
                            </TextField>
                        </Grid>
                        <Grid item sm={12} md={6} lg={3}>
                            <TextField
                                select
                                margin="dense"
                                id="role"
                                label="Role"
                                type="name"
                                fullWidth
                                variant="standard"
                                name="role"
                                onChange={handleChange}
                                defaultValue={"" || role}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            >
                                <MenuItem value="" selected="Select Role">
                                    Select Role
                                </MenuItem>
                                <MenuItem value="Admin">Admin</MenuItem>
                                {/* <MenuItem value="bank">Bank</MenuItem>
                                <MenuItem value="dealer">Dealer</MenuItem> */}
                            </TextField>
                        </Grid>
                        {/* <Grid item sm={12} md={6} lg={3}>
                                                <TextField
                                                    margin="dense"
                                                    id="name"
                                                    label="Master Module Id"
                                                    type="number"
                                                    fullWidth
                                                    variant="standard"
                                                    name="masterModuleId"
                                                    onChange={handleChange}
                                                    defaultValue={"" || masterModuleId}
                                                >
                                                </TextField>
                                            </Grid> */}
                        {/* <Grid item sm={12} md={6} lg={3}>
                                                <TextField
                                                    margin="dense"
                                                    id="name"
                                                    label="Module Id"
                                                    type="number"
                                                    fullWidth
                                                    variant="standard"
                                                    name="moduleId"
                                                    onChange={handleChange}
                                                    defaultValue={"" || moduleId}
                                                >
                                                </TextField>
                                            </Grid> */}
                    </Grid>
                    {/*  */}
                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px" }}
                    >
                        <Grid item sm={12} md={6} lg={3}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}


                                variant="contained"
                                onClick={searchFunction}
                            >
                                Search<SearchIcon />
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>

                {isLoading ? (<LoadingSpinner />) : (getSubModuleMasterTable.length == undefined || getSubModuleMasterTable.length == 0) ? (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }}
                                    className="themeText"

                                >
                                    Sub Module Details
                                </Typography>
                            </Grid>

                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 tableHeaderColor"
                                    variant="secondary"
                                // className="my-3"
                                // variant="secondary"
                                // style={{ backgroundColor: "#00b9f5", color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                ) : (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }}
                                    className="themeText"

                                >
                                    Sub Module Details
                                </Typography>
                            </Grid>
                            <TableContainer component={Paper} className="my-3">
                                <Table
                                    className={classes.table}
                                    style={{ padding: "6px 20px 6px 16px !important" }}
                                    size="small"
                                    aria-label="a dense table"
                                >
                                    <TableHead>
                                        <TableRow className='tableHeaderColor'>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Module ID
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Master Module Name
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Sub Module Name
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Role
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Action
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {getSubModuleMasterTable &&
                                            []
                                                .concat(getSubModuleMasterTable)
                                                .slice(
                                                    page * rowsPerPage,
                                                    page * rowsPerPage + rowsPerPage
                                                )
                                                .map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell align="center">
                                                            {row.moduleId ? row.moduleId : '-'}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.moduleName ? row.moduleName : '-'}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.subModuleName ? row.subModuleName : '-'}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.role === '' ? '-' : row.role}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <CustomButton
                                                                style={{
                                                                    padding: "8px"
                                                                }}
                                                                onClick={() =>
                                                                    editModalOpen(row.moduleName, row.subModuleName, row.role, row.moduleId, row.masterModuleId, row.moduleName)
                                                                }
                                                            >
                                                                {
                                                                    <EditIcon
                                                                        style={{
                                                                            color: "#fff",
                                                                            fontSize: "20px"
                                                                        }}
                                                                    />
                                                                }
                                                            </CustomButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={getSubModuleMasterTable.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </TableContainer>
                        </Grid>
                    </Card>
                )}
            </Layout>

            <div>
                <Dialog open={editOpen} onClose={handleClose}>
                    <DialogTitle>Edit Sub Module</DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Master Module Name"
                            type="name"
                            name='editMasterModuleName'
                            disabled
                            fullWidth
                            variant="standard"
                            value={editMasterModuleName || ""}
                            onChange={changeEdit}
                        />
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Sub Module Name"
                            type="name"
                            name='editSubModuleName'
                            fullWidth
                            variant="standard"
                            value={editSubModuleName || ""}
                            onChange={changeEdit}
                        />
                        {/* <TextField
                                        margin="dense"
                                        id="name"
                                        label="Role"
                                        type="name"
                                        fullWidth
                                        name='editsubModuleRole'
                                        variant="standard"
                                        value={editsubModuleRole || ""}
                                        onChange={changeEdit}
                                    /> */}
                        <TextField
                            disabled
                            margin="dense"
                            id="role"
                            label="Role"
                            type="name"
                            fullWidth
                            variant="standard"
                            name="editsubModuleRole"
                            onChange={changeEdit}
                            defaultValue={editsubModuleRole || ''}
                        >
                            <MenuItem value="" selected="Select Role">
                                Select Role
                            </MenuItem>
                            <MenuItem value="Admin">Admin</MenuItem>
                            {/* <MenuItem value="BANK">Bank</MenuItem>
                            <MenuItem value="DEALER">Dealer</MenuItem> */}
                        </TextField>

                    </DialogContent>
                    <DialogActions style={{ padding: "14px" }}>
                        <CustomButton
                            style={{
                                padding: "8px"
                            }}
                            variant="contained"
                            onClick={handleClose}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                padding: "8px"
                            }}
                            variant="contained"
                            disabled={!editSubModuleName}
                            onClick={editFunction}
                        >
                            Edit
                        </CustomButton>
                    </DialogActions>
                </Dialog>
            </div>

            <div>
                <Dialog open={addSubModuleModal} onClose={closeaddModuleModal}>
                    <DialogTitle>Add Module</DialogTitle>
                    <DialogContent>
                        <TextField
                            select
                            margin="dense"
                            id="role"
                            label="Select Master Module"
                            type="name"
                            fullWidth
                            variant="standard"
                            name="addMasterModule"
                            onChange={addSubModuleChange}
                            defaultValue={addMasterModule || ''}
                            InputProps={{
                                sx: {
                                    "&:before": { borderBottomColor: "gray" }, // before focus
                                    "&:after": { borderBottomColor: "gray" },  // after focus
                                },
                            }}
                            InputLabelProps={{
                                sx: { color: 'gray' }, // Optional: if you want the label to be white
                            }}
                        >
                            <MenuItem value="" selected="Select Role">
                                Select Role
                            </MenuItem>
                            {
                                masterModuleValues && masterModuleValues.map(x => {
                                    return (
                                        <MenuItem key={x.moduleId} value={`${x.moduleName}-${x.moduleId}`} >{x.moduleName}</MenuItem>
                                    )
                                })
                            }
                        </TextField>
                        <TextField
                            margin="dense"
                            required
                            id="name"
                            label="Sub Module Name"
                            type="name"
                            name='addSubModuleName'
                            fullWidth
                            variant="standard"
                            value={addSubModuleName || ""}
                            onChange={addSubModuleChange}
                            InputProps={{
                                sx: {
                                    "&:before": { borderBottomColor: "gray" }, // before focus
                                    "&:after": { borderBottomColor: "gray" },  // after focus
                                },
                            }}
                            InputLabelProps={{
                                sx: { color: 'gray' }, // Optional: if you want the label to be white
                            }}
                        />
                        <TextField
                            select
                            margin="dense"
                            id="role"
                            label="Role"
                            type="name"
                            fullWidth
                            variant="standard"
                            name="addSubModuleRole"
                            onChange={addSubModuleChange}
                            defaultValue={addSubModuleRole || ''}
                            InputProps={{
                                sx: {
                                    "&:before": { borderBottomColor: "gray" }, // before focus
                                    "&:after": { borderBottomColor: "gray" },  // after focus
                                },
                            }}
                            InputLabelProps={{
                                sx: { color: 'gray' }, // Optional: if you want the label to be white
                            }}
                        >
                            <MenuItem value="" selected="Select Role">
                                Select Role
                            </MenuItem>
                            <MenuItem value="Admin">Admin</MenuItem>
                            {/* <MenuItem value="bank">Bank</MenuItem>
                            <MenuItem value="dealer">Dealer</MenuItem> */}
                        </TextField>

                    </DialogContent>
                    <DialogActions style={{ padding: "14px" }}>
                        <CustomButton
                            style={{
                                padding: "8px"
                            }}
                            variant="contained"
                            onClick={closeaddModuleModal}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                padding: "8px"
                            }}
                            variant="contained"
                            onClick={addSubModuleSubmit}
                            disabled={!addSubModuleName}
                        >
                            Add
                        </CustomButton>
                    </DialogActions>
                </Dialog>
            </div>

            {addupdatesubmodulemaster.data.status == "success" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {editSubModuleResp}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {addupdatesubmodulemaster.data.status == "failed" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {editSubModuleResp}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    )

}
export default AddSubModulesAdmin;

